import React, { useCallback, useState } from 'react';
import { Modal, Row, Radio } from 'antd';
import { useTranslation } from 'react-i18next'
import { noop } from 'lodash';
import Exclamation from 'src/assets/img/icon_exclamation_circle.svg'
import DoubleArrowImage from 'src/assets/img/double-arrow.svg';
import PeopleItem from 'src/components/people-item';
import NeedsItem from 'src/components/need-item';
import FormItem from 'src/components/form-item';
import { FitPeopleLabel } from 'src/components/fit-people-label';
import './style.scss';
import MatchRequisitionModal from '../matchRequisitionModal/MatchRequisitionModal';

function MatchModal({ deallocation, needs, user, onClose, onSave, loading }) {
    const activeDeallocationNeeds = deallocation.needs.filter(
        dn => dn.fits?.active === 'Y' && dn.fits?.match === 'N' && dn.fits?.responsibleId === user.id
    );

    const initialNeedId = activeDeallocationNeeds.length === 1 ? activeDeallocationNeeds[0].id : null;
    const [selectedNeedId, setSelectedNeedId] = useState(initialNeedId);

    const selectedDeallocationNeed = activeDeallocationNeeds.find(dn => dn.id === selectedNeedId);
    const selectedNeed = selectedNeedId ? needs.find(n => n.id === selectedNeedId) : null;
    const selectedFitId = selectedDeallocationNeed?.fits?.id ?? null;

    const { t } = useTranslation();
    const [openRequisitionModal, setOpenRequisitionModal] = useState(false);

    const onOk = useCallback(() => {
        setOpenRequisitionModal(true);
    }, []);

    const onCancel = useCallback(() => {
        if (loading) return;
        onClose();
    }, [loading, onClose]);

    const needOptions = activeDeallocationNeeds.map(dn => {
        const need = needs.find(n => n.id === dn.id);
        if (!need) return null;
        const isOptMatch = deallocation.deallocation_suggestion.find(s => s.requisitionCode === need.requisitionCode);
        const labelType = isOptMatch ? 'fit-opt-match' : 'fit';
        return (
            <Radio key={dn.id} value={dn.id} aria-label={need.title}>
                <FitPeopleLabel type={labelType}>
                    <NeedsItem need={need} className={`profile-match__container_fit ${labelType}`} />
                </FitPeopleLabel>
            </Radio>
        );
    }).filter(Boolean);

    return (
        <>
        {selectedNeed && (
            <MatchRequisitionModal
                reqTitle={selectedNeed.title}
                visible={openRequisitionModal}
                reqCode={selectedNeed.requisitionCode}
                setVisible={setOpenRequisitionModal}
                login={deallocation.collaborator_deallocation.login}
                onConfirmMatch={(startDate, allocationType) => onSave(selectedFitId, startDate, allocationType)}
            />
        )}

        <Modal
            title={t('decideMatch')}
            width={1000}
            className="profile-match"
            visible={true}
            confirmLoading={loading}
            onCancel={onCancel}
            onOk={onOk}
            okButtonProps={{ className: 'cit-btn primary-type', disabled: !selectedNeedId }}
            cancelButtonProps={{ className: 'cit-btn link-type cancel-button' }}
            cancelText={t('back')}
            okText={t('confirmMatch')}
            aria-modal="true">
            <div className="profile-match__subtitle">
                <Row className='filters' align="top">
                    <div className='profile-match__subtitle_gutter' tabIndex={0} role='note'>
                        {t('confirmMatchSubtitle')}
                    </div>
                </Row>
            </div>
            <div className="profile-match__container">
                <FormItem label={t('profile')}>
                    <div className='profile-match__container_profile'>
                        <div className="option-list">
                            <PeopleItem people={deallocation} />
                        </div>
                    </div>
                </FormItem>
                <div className="profile-match__container_arrow">
                    <img src={DoubleArrowImage} alt="match arrow" className="match-arrow-image" />
                </div>
                <div className="option-list">
                    {needOptions.length === 1 ? (
                        needOptions[0]
                    ) : (
                        <Radio.Group
                            value={selectedNeedId}
                            onChange={e => setSelectedNeedId(e.target.value)}
                        >
                            {needOptions}
                        </Radio.Group>
                    )}
                </div>
            </div>

            <div className='profile-match__alert' tabIndex={0} role="alert" aria-describedby='alert-container'>
                <img src={Exclamation} alt="exclamation" role='none'/>
                <span role='alert'>{t('decisionRegardingMatch')}</span>
            </div>
        </Modal>
        </>
    );
}

MatchModal.defaultProps = {
    needs: [],
    onClose: noop,
    onSave: noop,
    loading: false,
    deallocation: {},
    user: {},
};

export default MatchModal;
